import type { Steps as StepsData } from "~/core";

export const isSteps = (item: unknown): item is StepsData => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "steps"
  );
};
